module.exports = __webpack_public_path__ + "static/media/icon_monotributista.e83e9183.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_monotributista.svg
// module id = 333
// module chunks = 0